import angular from 'angular';
import {NewDoorService} from "./new-door.service";

export default angular.module('slViz.newDoorModule', [])
    .service('NewDoorService', NewDoorService)
    .name;



// WEBPACK FOOTER //
// ./src/js/components/new-door/index.js